import './App.css';
import './fonts.css';
import './i18n';
import { AppProvider } from './providers';

window.addEventListener('pageshow', (event) => {
  if (event.persisted) window.location.reload();
});

const App: React.FC = () => {
  return <AppProvider />;
};

export default App;
